import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase";
import { FIREBASE_COLLECTIONS } from "../config/firebaseCollections";

const AUTH_ANALYTICS_EVENTS = new Set([
  "login_google",
  "login_google_rejected_new_user",
  "signup_google",
  "provider_link_success",
  "provider_link_failure",
  "auth_bootstrap_blocked",
  "auth_bootstrap_retry",
  "auth_bootstrap_recovered",
  "auth_bootstrap_persistence_reset",
]);

const AUTH_AUDIT_EVENTS = new Set([
  "auth_provider_linked",
  "auth_provider_unlinked",
  "duplicate_account_attempt",
  "google_login_rejected_new_user",
]);

const safeDataLayerPush = (eventName, params = {}) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};

const safeGtagEvent = (eventName, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("event", eventName, params);
};

export function trackAuthAnalyticsEvent(eventName, params = {}) {
  if (!AUTH_ANALYTICS_EVENTS.has(eventName)) {
    return;
  }

  safeDataLayerPush(eventName, params);
  safeGtagEvent(eventName, params);
}

export async function logAuthAuditEvent(eventName, params = {}) {
  if (!AUTH_AUDIT_EVENTS.has(eventName)) {
    return;
  }

  safeDataLayerPush(eventName, params);

  const uid = params.uid || auth.currentUser?.uid;
  if (!uid) {
    return;
  }

  try {
    await addDoc(
      collection(db, FIREBASE_COLLECTIONS.USERS, uid, "authEvents"),
      {
        eventName,
        providerId: params.providerId || null,
        reason: params.reason || null,
        source: params.source || null,
        createdAt: serverTimestamp(),
      }
    );
  } catch (error) {
    console.warn("Failed to write auth audit event:", error);
  }
}
